import { create } from "zustand";

const eventStore = create((set) => ({
  event: {},

  setEvent: (data) => set({ event: data }),

  reset: () => {
    set({ event: {} });
  },
}));

export default eventStore;
